import { FC, useEffect } from "react";
import { Button } from "../../shared/button/Button";
import { LessorAvatar } from "../../shared/lessor/LessorAvatar";
import { SecondTitle } from "../../shared/secondTitle/SecondTitle";
import { Text } from "../../shared/Text/Text";
import styles from "./ui/index.module.css";
import { ModalProps } from "../auth/login/model/types";
import closeIcon from "../../assets/icons/close.svg";

interface Props extends ModalProps {
  userInfo: any;
  userEmail: any;
  closeModal: () => void;
}

const renderButton = (name: string, value: string | null, handleButtonClick: (value: string, name: string) => void) => {
  if (!value) return null;
  
  if (name === "Telegram") {
    return (
      <Button
        $icon
        $iconColor
        $iconBgColor="rgba(40, 40, 40, 1)"
        className={styles.social_btn}
        onClick={() => handleButtonClick(value, name)}
      >
        {name}
      </Button>
    );
  }

  return (
    <Button
      $icon
      $iconColor
      $iconBgColor="rgba(40, 40, 40, 1)"
      className={styles.social_btn}
    >
      {value}
    </Button>
  );
};

const renderSocialLink = (name: string, value: string | null) => {
  if (!value) return null;
  if (name === "Email" && value.endsWith("@t.me")) return null;
  
  if (name === "Email" && value.includes("@")) {
    return (
      <Text color="white" fw="400" className={styles.social_link}>
        {name}: <a href={`mailto:${value}`} style={{ color: 'inherit', textDecoration: 'underline' }}>{value}</a>
      </Text>
    );
  }

  if (value.startsWith("https://")) {
    return (
      <Text color="white" fw="400" className={styles.social_link}>
        {name}: <a href={value} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>{value}</a>
      </Text>
    );
  }

  return (
    <Text color="white" fw="400" className={styles.social_link}>
      {name}: {value}
    </Text>
  );
};

const ContactsPopUp: FC<Props> = ({ userInfo, userEmail, closeModal }) => {
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [closeModal]);

  const handleButtonClick = (value: string, name: string) => {
    if (name === "Telegram") {
      window.open(`https://t.me/${value}`, "_blank");
    }
  };

  const handlePopupClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleCloseClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    closeModal();
  };

  return (
    <div 
      onClick={closeModal}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000
      }}
    >
      <div className={styles.header_container} onClick={handlePopupClick}>
        <div className={styles.close_icon} onClick={handleCloseClick}>
          <img src={closeIcon} alt="close icon" />
        </div>
        <div className={styles.header}>
          <LessorAvatar
            className={styles.header_img}
            src={
              userInfo.picture_url || "https://i.pinimg.com/564x/25/ee/de/25eedef494e9b4ce02b14990c9b5db2d.jpg"
            }
          />
          <div>
            <SecondTitle>{userInfo.full_name}</SecondTitle>
            <Text>{userInfo.description}</Text>
          </div>
        </div>
        <div className={styles.container_links}>
          <div>
            <SecondTitle className={styles.links_btn} color="white">
              Book an apartment
            </SecondTitle>
            <Text color="white" fw="400">
              Contact {userInfo.full_name} in Telegram:
            </Text>
            <div className={styles.container_buttons}>
              {renderButton("Telegram", userInfo.telegram, handleButtonClick)}
            </div>
          </div>

          <div>
            <Text color="white" fw="400">
              Or in other social networks:
            </Text>
            <div className={styles.social_links_container}>
              {renderSocialLink("Instagram", userInfo.instagram)}
              {renderSocialLink("LinkedIn", userInfo.linkedin)}
              {renderSocialLink("WhatsApp", userInfo.whatsapp)}
              {renderSocialLink("Email", userEmail.email)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactsPopUp;
